export default "__VITE_ASSET__Cznr$XRw__"